// extracted by mini-css-extract-plugin
export default {"paging":"style-paging-3FPnc","panel":"style-panel-4nIP2","list":"style-list-2D-Pn"};